import React, { Component } from 'react'

const ConditionalContainer = ({ show, children }) => {
    return show ? children : null
}

export default ConditionalContainer
